import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { routes } from 'app/routing/routesConfig';
import { useAppSelector } from 'app/store';
import { getAuthenticatedSelector } from 'app/store/Auth/selectors';

export const PrivateRoute = ({ children }) => {
  const isAuthenticated = useAppSelector(getAuthenticatedSelector);
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to={{
          pathname: routes.auth.path,
          search: location.search,
        }}
        state={{ from: location.pathname || '' }}
      />
    );
  }

  return children || <Outlet />;
};
